import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'shared/components/Icon';

const NavButton = ({ id, label, icon, onClick }) => (
  <li className="btn">
    {/* TODO: Write CSS so that this can be a `button` instead of `a` */}
    <a id={id} onClick={onClick}>
      <Icon name={icon} />
      <span className="text">{label}</span>
    </a>
  </li>
);

NavButton.displayName = 'NavButton';

NavButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default NavButton;
